// pages/Dashboard.jsx
import React from 'react';
import { Link } from "react-router-dom";
import Header from "../components/Header";
import ServiceList from '../pages/ServiceList';
import Footer from "../components/Footer"; // Importe le footer

const Dashboard = () => {
  const userData = JSON.parse(localStorage.getItem("user") || "null");

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--app-background)' }}>
      <Header />

      <main className="max-w-7xl mx-auto p-6">
        <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
          <p className="text-sm font-semibold uppercase tracking-[0.12em] text-[#d6429b] mb-2">
            Communauté de créateurs de coeur
          </p>
          <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
            <span className="text-black">Bienvenue </span>
            <span className="text-[var(--accent-primary)]">{userData?.prenom || "sur Vivacrea"}</span>
          </h1>
          <p className="text-gray-600">
            Découvrez les talents de notre communauté de Créateurs singuliers.
          </p>
          <div className="mt-4">
            <Link to="/createurs" className="inline-flex items-center gap-2 text-white bg-[var(--accent-primary)] hover:bg-[var(--accent-primary-hover)] rounded-lg px-4 py-2 font-medium transition-colors">
              <span>Voir tous les créateurs</span>
              <span className="text-lg leading-none text-white">→</span>
            </Link>
          </div>
        </div>

        <ServiceList />
      </main>
            <Footer /> {/* Ajoute le footer ici */}

    </div>
  );
};

export default Dashboard;